"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDealExchangeDeal = exports.isSpDraftDeal = void 0;
var isSpDraftDeal = function (dealXgId) {
    return !!dealXgId && dealXgId.startsWith('accelerate_');
};
exports.isSpDraftDeal = isSpDraftDeal;
var isDealExchangeDeal = function (dealXgId) {
    return !!dealXgId && !dealXgId.startsWith('accelerate_');
};
exports.isDealExchangeDeal = isDealExchangeDeal;
